import JiraConnections from "./JiraConnections";

export default JiraConnections;